import Accordion from './modules/accordionModule';
import Carousel from './modules/carouselModule';
import Counter from './modules/numberCounterModule';
import Menu from './modules/menuModule';
import glyphBlock from './modules/glyphBlockModule';
import fontSpecimenBlock from './modules/fontSpecimenModule';
import fontSpecimenVariableBlock from './modules/fontSpecimenVariableModule';
import FeaturedBlock from './modules/featuredBlockModule';
import abcd8LogoModule from './modules/abcd8LogoModule';
import CaseStudiesRive from './modules/caseStudiesRiveModule';
import CTABlockAnimation from './modules/ctaBlockAnimationModule';
import DoubleMediaRive from './modules/doubleMediaRiveModule';
import HeroLoadAnimation from './modules/heroLoadAnimationModule';
import VideoPlayer from './modules/videoModule';
import FeaturedElement from './modules/featuredElementModule';
import Footer from './modules/footerModule';
import testimonialAnimation from './modules/testimonialAnimationModule';
import splitTextModule from './modules/splitTextModule';
import animatedFavicon from './modules/animatedFavicon';
Menu();
Accordion();
Carousel();
Counter();
HeroLoadAnimation();
VideoPlayer();
glyphBlock();
fontSpecimenBlock();
fontSpecimenVariableBlock();
abcd8LogoModule();
CaseStudiesRive();
CTABlockAnimation();
DoubleMediaRive();
FeaturedElement();
FeaturedBlock();
Footer();
testimonialAnimation();
splitTextModule();
animatedFavicon();
